import React from 'react';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Registration from './registration';

describe('Registration', () => {
  test('renders Registration component', async () => {
    const date_of_birth_options = { 
      year: [
        {name: "1900(明治33年)", value: "1900"},
        {name: "1901(明治34年)", value: "1901"}
      ],
      month: [
        {name: 1, value: "01"},
        {name: 2, value: "02"}
      ],
      day: [
        {name: 1, value: "01"},
        {name: 2, value: "02"}]
    }
    const institution_key = 'goodshibuya';
    const plan_datetime_from = '202102060900'
    render(<Registration plan_datetime_from={plan_datetime_from} institution_key={institution_key} date_of_birth_options={date_of_birth_options} />);
    //screen.debug();


    expect(screen.getByText('1900(明治33年)')).toBeInTheDocument();
    expect(screen.getByText('1901(明治34年)')).toBeInTheDocument();
  });
});
